// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"357f8845","433":"e9f61543","453":"089a6ef4"}[chunkId] + ".chunk.js";
};